var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeaderboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Expand",
    transform: "translate(0 -2)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sit-n-go",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.545c-1.75 0-3.088-.662-4.113-1.682a6.811 6.811 0 01-.987-1.22c-1.326-1.988-1.925-4.595-2.188-6.52-.05-.378-.087-.736-.124-1.051-.038-.41-.063-.758-.075-1.02h14.975c-.013.262-.038.61-.075 1.02-.026.315-.076.673-.125 1.051-.263 1.925-.85 4.532-2.175 6.52a6.866 6.866 0 01-.988 1.22c-1.037 1.02-2.375 1.682-4.125 1.682zm-2.275 4.249l1.175-3.155h2.2l1.175 3.155h-4.55zm7.987 3.154H6.787l1.676-2.103h8.075l1.674 2.103zM1.262 3.123h2.675c.225 1.693.688 3.944 1.688 5.92C3.175 7.919 1.45 5.7 1.263 3.124zm19.8 0h2.675c-.187 2.577-1.912 4.795-4.362 5.92 1-1.976 1.462-4.227 1.688-5.92zM25 2.66c0-.2-.012-.389-.038-.588h-3.788c.076-.863.076-1.441.076-1.546 0-.295-.275-.526-.625-.526H4.375c-.35 0-.625.231-.625.526 0 .105 0 .683.076 1.546H.038C.013 2.272 0 2.46 0 2.66c0 3.692 2.75 6.815 6.537 7.866.9 1.241 2.1 2.25 3.688 2.734l-1.313 3.534h-.787c-.213 0-.4.084-.525.231L5.1 20.18a.463.463 0 00-.024.547.66.66 0 00.549.273h13.75a.66.66 0 00.549-.273.463.463 0 00-.024-.547l-2.5-3.155a.677.677 0 00-.525-.231h-.788l-1.312-3.534c1.588-.483 2.787-1.493 3.687-2.734C22.25 9.475 25 6.352 25 2.66z",
    id: "Fill-1"
  }))))));
}

SvgLeaderboard.displayName = 'Leaderboard';
export default SvgLeaderboard;